// These are the pages you can go to.
// They are all wrapped in the App component, which should contain the navbar etc
// See http://blog.mxstbr.com/2016/01/react-apps-with-pages for more information
// about the code splitting business

const errorLoading = err => {
    console.error('Dynamic page loading failed', err); // eslint-disable-line no-console
};

const loadModule = cb => componentModule => {
    cb(null, componentModule.default);
};

export default function createRoutes(store) {
    return [
        {
            path: '/',
            name: 'home',
            getComponent(nextState, cb) {
                import('./containers/HomePage')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/konfigurator',
            name: 'konfigurator',

            getComponent(location, cb) {
                import('./containers/Konfigurator')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            },
            childRoutes: [
                {
                    path: '/konfigurator/:slug',
                    name: 'cfgProductSingle',
                    getComponent(location, cb) {
                        import('./containers/Konfigurator/ProductSingle')
                            .then(loadModule(cb))
                            .catch(errorLoading);
                    }
                }
            ]
        },
        {
            path: '/produkty',
            name: 'produkty',
            getComponent(location, cb) {
                import('./containers/Products')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            },
            childRoutes: [
                {
                    path: '/produkty/:slug',
                    name: 'productSingle',
                    getComponent(location, cb) {
                        import('./containers/Products/ProductSingle')
                            .then(loadModule(cb))
                            .catch(errorLoading);
                    }
                }
            ]
        },
        {
            path: '/kosik',
            name: 'cartOverview',
            getComponent(location, cb) {
                import('./containers/CartOverview')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/doprava-platba',
            name: 'cartShipping',
            getComponent(location, cb) {
                import('./containers/CartShipping')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/balicek/:slug',
            name: 'packageDetail',
            getComponent(location, cb) {
                import('./containers/PackageDetail')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: 'objednavka-odeslana',
            name: 'orderSent',
            getComponent(location, cb) {
                import('./containers/OrderSent')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/nahled-pranicka',
            name: 'nahledPranicka',
            getComponent(location, cb) {
                import('./containers/NahledPranicka')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/informace-o-doprave',
            name: 'dopravaPlatba',
            getComponent(location, cb) {
                import('./containers/DopravaPlatba')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: 'caste-dotazy',
            name: 'casteDotazy',
            getComponent(location, cb) {
                import('./containers/CasteDotazy')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/kontakt',
            name: 'kontakt',
            getComponent(location, cb) {
                import('./containers/Kontakt')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/obchodni-podminky',
            name: 'obchodniPodminky',
            getComponent(location, cb) {
                import('./containers/ObchodniPodminky')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/ochrana-osobnich-udaju',
            name: 'OchranaOsobnichUdaju',
            getComponent(location, cb) {
                import('./containers/OchranaOsobnichUdaju')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/hotove-balicky',
            name: 'packageListPage',
            getComponent(location, cb) {
                import('./containers/PackageList')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/firemni-darky',
            name: 'proFirmy',
            getComponent(location, cb) {
                import('./containers/ProFirmy')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/lookbook',
            name: 'Galerie',
            getComponent(location, cb) {
                import('./containers/Galerie')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/inspirace',
            name: 'Inspirations',
            getComponent(location, cb) {
                import('./containers/Inspirations')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/inspirace/:slug',
            name: 'Inspiration',
            getComponent(location, cb) {
                import('./containers/Inspiration')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '/svatebni-balicky',
            name: 'SvatebniBalicky',
            getComponent(location, cb) {
                import('./containers/SvatebniBalicky')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },

        {
            path: 'o-nas',
            name: 'ONas',
            getComponent(location, cb) {
                import('./containers/ONas')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: 'stav-platby',
            name: 'stavPlatby',
            getComponent(location, cb) {
                import('./containers/StavPlatby')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        },
        {
            path: '*',
            name: 'notfound',
            getComponent(nextState, cb) {
                import('./containers/NotFoundPage')
                    .then(loadModule(cb))
                    .catch(errorLoading);
            }
        }
    ];
}
